const DEFAULT_STATS = [
  { value: '150k+', label: 'Users found their dream job' },
  { value: '30days', label: 'Average time to first job offer' },
  { value: '+32%', label: 'Average pay jump' },
  { value: '40h+', label: 'Saved every month' },
];

const mobileBorders = [
  'border-b border-[#DFDFDF]',
  'border-b border-l border-[#DFDFDF]',
  '',
  'border-l border-[#DFDFDF]',
];

/**
 * `background` overrides the MomApply pink gradient (RemoteApply passes its blue one);
 * `stats` overrides the four `{ value, label }` tiles.
 */
const BenefitsSection = ({
  background = 'bg-gradient-to-b from-[#FFF8F5] via-[#FFEFEE] to-[#FFE7EB]',
  stats = DEFAULT_STATS,
}) => (
  <section className={`w-full py-6 md:py-16 ${background}`}>
    <div className="max-w-[1300px] mx-auto px-6 md:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:hidden">
        {stats.map((stat, i) => (
          <div key={i} className={`flex flex-col items-center gap-1 py-4 ${mobileBorders[i]}`}>
            <span className="text-[32px] font-semibold leading-[1.25em] tracking-tight text-[#333]">{stat.value}</span>
            <span className="text-[16px] font-normal leading-[1.5em] text-[#535353] text-center">{stat.label}</span>
          </div>
        ))}
      </div>
      <div className="hidden md:flex md:justify-between md:gap-12">
        {stats.map((stat, i) => (
          <div key={i} className={`flex flex-col gap-1 ${i < stats.length - 1 ? 'border-r border-black/8 pr-12' : ''}`}>
            <span className="text-[32px] font-semibold leading-[1.25em] tracking-tight text-[#333]">{stat.value}</span>
            <span className="text-[16px] font-normal leading-[1.5em] text-[#535353]">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BenefitsSection;
